import {
  Box,
  ClickAwayListener,
  makeStyles,
  Theme,
  Tooltip,
} from '@material-ui/core'
import clsx from 'clsx'
import { useState } from 'react'
import { XIcon } from '@src/icons'

const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(12),
    padding: '0 !important',
    minWidth: '450px',
    boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.16)',
    whitespace: 'nowrap',
  },
  tooltipXL: {
    maxWidth: '600px',
    minWidth: '600px',
  },
  closeIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    cursor: 'pointer',
  },
  inconWrapper: {
    cursor: 'pointer',
  },
  arrow: {
    '&:before': {
      boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.2)',
    },
    color: theme.palette.common.white,
  },
  header: {
    background: theme.palette.background.grey,
    padding: theme.spacing(3, 5),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2),
  },
  body: {
    padding: theme.spacing(5, 4),
    gap: theme.spacing(4),
  },
  bodyXL: {
    display: 'flex',
    minHeight: '129px',
  },
}))

const MDTooltip = ({
  children,
  size,
  title,
  icon,
  onClick,
}: {
  children: any
  size: 'md' | 'lg'
  title: any
  icon: any
  onClick?: any
}) => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <div>
        <Tooltip
          classes={{
            arrow: classes.arrow,
            tooltip: clsx(classes.tooltip, {
              [classes.tooltipXL]: size === 'lg',
            }),
          }}
          title={
            <>
              <Box className={classes.header}>
                {title}
                <XIcon
                  className={classes.closeIcon}
                  onClick={() => setIsOpen(false)}
                />
              </Box>
              <Box
                className={clsx(classes.body, {
                  [classes.bodyXL]: size === 'lg',
                })}
              >
                {children}
              </Box>
            </>
          }
          leaveDelay={0}
          placement="left"
          onClose={() => setIsOpen(false)}
          open={isOpen}
          arrow
          disableFocusListener
          disableHoverListener
          disableTouchListener
          interactive
          PopperProps={{
            disablePortal: true,
          }}
        >
          <div
            onClick={() => {
              setIsOpen(true)
              onClick?.()
            }}
            className={classes.inconWrapper}
          >
            {icon}
          </div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  )
}

export default MDTooltip
